<template>
  <div class="filter-set number-of-rooms">
    <button
      @click.stop="$emit('toggle')"
      :class="getBoxClass()"
      class="filter-name"
      type="button"
      :aria-expanded="expanderVisible ? 'true' : 'false'"
      :aria-controls="config.testing.FILTER_ROOMS"
      id="number-of-rooms-toggle"
    >
      <span class="filter-name__label">Huoneluku</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </button>
    <expander :expanded="expanderVisible">
      <div
        :id="config.testing.FILTER_ROOMS"
        class="room-selector"
        role="region"
        aria-labelledby="number-of-rooms-toggle"
      >
        <div class="room" v-for="n in 5" :key="n">
          <button
            :id="checkboxId(n)"
            type="button"
            class="room-button"
            :class="{ selected: numberOfRoomsModel.includes(n) }"
            @click="toggleNumberOfRooms(n)"
            :aria-pressed="numberOfRoomsModel.includes(n) ? 'true' : 'false'"
            :aria-label="n === 1 ? '1 huone' : `${n} huonetta`"
          >
            {{ n === 5 ? '5+' : n }}
          </button>
        </div>
      </div>
    </expander>
  </div>
</template>

<script>
import config from '@/config';
import Expander from '../expander/expander.vue';
import searchUtils from '@/app/utils/search-utils';

export default {
  name: 'number-of-rooms',
  data: () => ({
    config,
    id: '',
  }),
  props: {
    expanderVisible: {
      type: Boolean,
      default: undefined, // By default, the expander is visible but without any complex close/open css logic
    },
    numberOfRooms: {
      type: [Array, Number],
      default: () => [],
    },
  },
  computed: {
    numberOfRoomsModel: {
      get() {
        return Array.isArray(this.numberOfRooms) ? this.numberOfRooms : [this.numberOfRooms];
      },
      set(value) {
        const updates = { numberOfRooms: value };
        searchUtils.addFilterToUrl(this.$router, this.$route, updates);
      },
    },
  },
  methods: {
    getBoxClass() {
      return this.numberOfRooms?.length ? 'in-use' : '';
    },
    checkboxId(n) {
      return `${this.id}-chk-${n}`;
    },
    toggleNumberOfRooms(n) {
      const newValue = [...this.numberOfRoomsModel];
      const idx = newValue.indexOf(n);
      if (idx !== -1) {
        newValue.splice(idx, 1);
      } else {
        newValue.push(n);
      }
      this.numberOfRoomsModel = newValue;
    },
  },
  mounted() {
    this.id = this.$.uid.toString();
  },
  components: {
    Expander,
  },
};
</script>
